$(function () {
  var windowWidth = document.documentElement.clientWidth;
  if (windowWidth < 1000) {
    $(".page-box").addClass("small-page-box");
    $(".page-view_box").addClass("small-page-view_box");
  }
  // 数组indexOf方法
  if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (elt /*, from*/) {
      var len = this.length >>> 0;

      var from = Number(arguments[1]) || 0;
      from = from < 0 ? Math.ceil(from) : Math.floor(from);
      if (from < 0) from += len;

      for (; from < len; from++) {
        if (from in this && this[from] === elt) return from;
      }
      return -1;
    };
  }

  // 解决不兼容isArray
  if (!Array.isArray) {
    Array.isArray = function (arg) {
      return Object.prototype.toString.call(arg) === "[object Array]";
    };
  }

  if (!Array.prototype.filter) {
    Array.prototype.filter = function (fun /*, thisArg */) {
      "use strict";
      if (this === void 0 || this === null) throw new TypeError();
      var t = Object(this);
      var len = t.length >>> 0;
      if (typeof fun !== "function") throw new TypeError();
      var res = [];
      var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
      for (var i = 0; i < len; i++) {
        if (i in t) {
          var val = t[i];
          if (fun.call(thisArg, val, i, t)) res.push(val);
        }
      }
      return res;
    };
  }

  // 解决不兼容forEach
  if (!Array.prototype.forEach) {
    Array.prototype.forEach = function forEach(callback, thisArg) {
      var T, k;
      if (this == null) {
        throw new TypeError("this is null or not defined");
      }
      var O = Object(this);
      var len = O.length >>> 0;
      if (typeof callback !== "function") {
        throw new TypeError(callback + " is not a function");
      }
      if (arguments.length > 1) {
        T = thisArg;
      }
      k = 0;
      while (k < len) {
        var kValue;
        if (k in O) {
          kValue = O[k];
          callback.call(T, kValue, k, O);
        }
        k++;
      }
    };
  }
  // IE 兼容object.assign方法
  if (typeof Object.assign != "function") {
    Object.assign = function (target) {
      "use strict";
      if (target == null) {
        throw new TypeError("Cannot convert undefined or null to object");
      }

      target = Object(target);
      for (var index = 1; index < arguments.length; index++) {
        var source = arguments[index];
        if (source != null) {
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
      }
      return target;
    };
  }
  //ie兼容trim方法
  if (!String.prototype.trim) {
    String.prototype.trim = function () {
      return this.replace(/^\s+|\s+$/g, "");
    };
  }
  // 解决不兼容object.keys
  if (!Object.keys) {
    Object.keys = (function () {
      var hasOwnProperty = Object.prototype.hasOwnProperty,
        hasDontEnumBug = !{ toString: null }.propertyIsEnumerable("toString"),
        dontEnums = [
          "toString",
          "toLocaleString",
          "valueOf",
          "hasOwnProperty",
          "isPrototypeOf",
          "propertyIsEnumerable",
          "constructor",
        ],
        dontEnumsLength = dontEnums.length;

      return function (obj) {
        if (
          (typeof obj !== "object" && typeof obj !== "function") ||
          obj === null
        )
          throw new TypeError("Object.keys called on non-object");

        var result = [];

        for (var prop in obj) {
          if (hasOwnProperty.call(obj, prop)) result.push(prop);
        }

        if (hasDontEnumBug) {
          for (var i = 0; i < dontEnumsLength; i++) {
            if (hasOwnProperty.call(obj, dontEnums[i]))
              result.push(dontEnums[i]);
          }
        }
        return result;
      };
    })();
  }

  // 解决Ie8不兼容maps
  if (!Array.prototype.map) {
    Array.prototype.map = function (callback, thisArg) {
      var T, A, k;

      if (this == null) {
        throw new TypeError(" this is null or not defined");
      }

      // 1. Let O be the result of calling ToObject passing the |this| value as the argument.
      var O = Object(this);

      // 2. Let lenValue be the result of calling the Get internal method of O with the argument "length".
      // 3. Let len be ToUint32(lenValue).
      var len = O.length >>> 0;

      // 4. If IsCallable(callback) is false, throw a TypeError exception.
      // See: http://es5.github.com/#x9.11
      if (typeof callback !== "function") {
        throw new TypeError(callback + " is not a function");
      }

      // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
      if (thisArg) {
        T = thisArg;
      }

      // 6. Let A be a new array created as if by the expression new Array(len) where Array is
      // the standard built-in constructor with that name and len is the value of len.
      A = new Array(len);

      // 7. Let k be 0
      k = 0;

      // 8. Repeat, while k < len
      while (k < len) {
        var kValue, mappedValue;

        // a. Let Pk be ToString(k).
        //   This is implicit for LHS operands of the in operator
        // b. Let kPresent be the result of calling the HasProperty internal method of O with argument Pk.
        //   This step can be combined with c
        // c. If kPresent is true, then
        if (k in O) {
          // i. Let kValue be the result of calling the Get internal method of O with argument Pk.
          kValue = O[k];

          // ii. Let mappedValue be the result of calling the Call internal method of callback
          // with T as the this value and argument list containing kValue, k, and O.
          mappedValue = callback.call(T, kValue, k, O);

          // iii. Call the DefineOwnProperty internal method of A with arguments
          // Pk, Property Descriptor {Value: mappedValue, : true, Enumerable: true, Configurable: true},
          // and false.

          // In browsers that support Object.defineProperty, use the following:
          // Object.defineProperty(A, Pk, { value: mappedValue, writable: true, enumerable: true, configurable: true });

          // For best browser support, use the following:
          A[k] = mappedValue;
        }
        // d. Increase k by 1.
        k++;
      }

      // 9. return A
      return A;
    };
  }

  $.support.cors = true;
  // $.ajaxSetup({
  //   xhr: function () {
  //     if (window.ActiveXObject) {
  //       return new window.ActiveXObject("Microsoft.XMLHTTP");
  //     } else {
  //       return new window.XMLHttpRequest();
  //     }
  //   },
  // });
  if (window.location.hash.indexOf("/home/fund-f10/fundlist") !== -1) {
    $(".page-detail-header").hide();
  } else {
    $(".page-detail-header").show();
  }
  var routerQuery = router.parse();
  var gStockCode = routerQuery.param.s;
  var lct = routerQuery.param.lct;
  var butFlag = routerQuery.param.butFlag; //是否能够点击
  let params = {};
  var tabId = routerQuery.url.split("/")[3];
  if (lct) {
    params.lct = lct;
  }
  if (gStockCode) {
    params.s = gStockCode;
  }
  if (butFlag) {
    params.butFlag = butFlag;
  }

  window.routerChange = function () {
    console.log(routerQuery.url, "触发了");
    let newRouterQuery = router.parse();
    if (newRouterQuery.url.indexOf("home/fund-f10/fundlist") === -1) {
      let routerKey = newRouterQuery.url.split("/")[3];
      createdTabActive(routerKey);
    }
  };
  var createdTabActive = function (tabId) {
    $(".tab-item").removeClass("active-tab-item");
    $("#" + tabId + "Id").addClass("active-tab-item");
  };
  createdTabActive(tabId);
  /***
   * 最新动态模块
   */
  var tabNewsTarget = $("#fundNewsId");
  tabNewsTarget.on("click", function () {
    // 跳转最新动态
    location.hash = router.stringify("/home/fund-f10/fundNews", params);
    createdTabActive("fundNews");
  });

  var tabOverviewTarget = $("#fundOverviewId");
  tabOverviewTarget.on("click", function () {
    // 跳转基金概况
    location.hash = router.stringify("/home/fund-f10/fundOverview", params);
    createdTabActive("fundOverview");
  });

  var tabManagerTarget = $("#fundManagerId");
  tabManagerTarget.on("click", function () {
    // 跳转基金经理
    location.hash = router.stringify("/home/fund-f10/fundManager", params);
    createdTabActive("fundManager");
  });

  var tabCompanyTarget = $("#fundCompanyId");
  tabCompanyTarget.on("click", function () {
    // 跳转基金公司
    location.hash = router.stringify("/home/fund-f10/fundCompany", params);
    createdTabActive("fundCompany");
  });

  var tabCompanyTarget = $("#fundScaleId");
  tabCompanyTarget.on("click", function () {
    // 跳转基金规模
    location.hash = router.stringify("/home/fund-f10/fundScale", params);
    createdTabActive("fundScale");
  });

  var tabScaleTarget = $("#fundHoldId");
  tabScaleTarget.on("click", function () {
    // 跳转基金持仓
    location.hash = router.stringify("/home/fund-f10/fundHold", params);
    createdTabActive("fundHold");
  });

  var tabAnnouncementTarget = $("#fundAnnouncementId");
  tabAnnouncementTarget.on("click", function () {
    // 跳转基金公告
    location.hash = router.stringify("/home/fund-f10/fundAnnouncement", params);
    createdTabActive("fundAnnouncement");
  });

  var tabHoldTarget = $("#tabHoldId");
  tabHoldTarget.on("click", function () {
    // 跳转基金持仓模块
    location.hash = router.stringify("/home/fund-f10/fundHold", params);
  });

  /**
   * 格式化金额数据
   */
  var formatCurrency = function (number) {
    try {
      {
        // 对于IE8及以下，Number.prototype.toLocaleString不存在
        if (!Number.prototype.toLocaleString) {
          // 实现简单的千分位分隔
          var parts = number.toString().split(".");
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return parts.join(".");
        } else {
          // 对于支持Intl的浏览器，使用toLocaleString
          return number.toLocaleString();
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  //获取基金代码
  var dxList = []; //代销列表
  var fundList = []; //基金列表
  var tagList = []; //标签列表
  var fundData = {}; //基金信息
  var fundBaseInfo = {};
  // var isDTVisible = false; //是否展示定投
  const qrUrl = $.base64.encode(`BOSC|16|PIBS|||||${gStockCode}`);
  //生成二维码
  var createdQrcode = function () {
    //table 模式兼容 IE低版本
    $("#qrcodeImg").qrcode({
      render: "table", //table模式
      width: 80, //宽度
      height: 80, //高度
      text: qrUrl, //生成二维码的内容
    });
  };

  createdQrcode();

  //初始化代销列表
  var initDxList = function () {
    if (!gStockCode) return;
    $.ajax({
      url: "https://minfo.gildata.com/memcached/json?42739_CustomFundList",
      // cache: false,
      success: function (res) {
        dxList = res;
        initFundMarket();
      },
      error: function (XMLHttpRequest, textStatus, errorThrown) {
        console.log(XMLHttpRequest.readyState);
        console.log(textStatus);
      },
      dataType: "json",
    });
  };

  //基金列表
  var initFundMarket = function () {
    $.ajax({
      url: "https://minfo.gildata.com/memcached/json/?42739_fundRank",
      success: function (res) {
        let changeList = tableChange(
          res.data.rows.columnData || [],
          res.data.rows.columnName || []
        );
        let filterList = changeList.filter((item) => {
          return item.FourthNature == "1" || item.FourthNature == "2";
        });
        fundList = filterList || [];
        fundData =
          _.find(fundList, function (item) {
            return item.SecuCode === gStockCode;
          }) || {};
        initTzStyle();
      },
      dataType: "json",
    });
  };

  //创建title
  var craetedTitle = function () {
    $("#fund_title").html(fundBaseInfo.secuabbr || "--");
    $("#fund_code").html(fundBaseInfo.secucode || gStockCode || "--");
  };

  //创建基金标签
  var createdTag = function () {
    let tagStr = "";
    for (let t_index = 0; t_index < tagList.length; t_index++) {
      const item = tagList[t_index];
      if (item.label) {
        var tagClass = "header-tag";
        if (item.type === "hot") {
          tagClass += " hot-tag";
        }
        if (item.type === "float-rate") {
          tagClass += " float-rate-tag";
        }
        tagStr =
          tagStr +
          `<span class="${tagClass}">
            ${item.label}
            </span>`;
      }
    }
    $(".header-tag-box").html(tagStr);
  };

  //展示定投按钮
  var showDtBtn = function () {
    //首先在列表数据里，第五属性为1 或者2 并且客户传递的为1跨境通客户
    if (
      (fundData.FifthNature == "1" || fundData.FifthNature == "2") &&
      lct == "1"
    ) {
      $(".dt_btn").show();
    }

    if (butFlag == "1") {
      $(".btn").addClass("active-btn");
      $(".btn").removeClass("disabled-btn");
    }
  };

  //获取投资风格
  var initTzStyle = function () {
    $.ajax({
      url: `https://minfo.gildata.com/memcached/json/?${gStockCode}_FundOverview`,
      dataType: "json",
      success: function (res) {
        if (res.RiskIncomeCharsValue && res.RiskIncomeCharsValue.length) {
          for (const key in res.RiskIncomeCharsValue[0]) {
            fundBaseInfo[key] = res.RiskIncomeCharsValue[0][key];
          }
        }
        if (res.fundOverviewValue && res.fundOverviewValue.length) {
          for (const key in res.fundOverviewValue[0]) {
            fundBaseInfo[key] = res.fundOverviewValue[0][key];
          }
        }
        // 基金类型 //客户传了取客户的，客户没传取系统的
        if (fundBaseInfo.dataname) {
          tagList.push({
            label: fundBaseInfo.dataname,
          });
        }
        //基金风险
        if (fundBaseInfo.fundtypecode) {
          tagList.push({
            label: fundBaseInfo.fundtypecode,
          });
        }
        //投资风格
        if (fundBaseInfo.fundstylename) {
          tagList.push({
            label: fundBaseInfo.fundstylename,
          });
        }
        //基金主题
        if (fundBaseInfo.fundtagname) {
          tagList.push({
            label: fundBaseInfo.fundtagname,
          });
        }
        //起投金额
        if (fundData.amountofstartinginvestment) {
          tagList.push({
            label: `起购金额${formatCurrency(
              fundData.amountofstartinginvestment,
              {
                precision: 2,
              }
            )}元`,
            type: "hot",
          });
        }
        craetedTitle();
        // 先渲染基础标签
        createdTag();
        // 然后获取浮动费率数据并追加标签
        initFloatRate();
        showDtBtn();
      },
    });
  };

  // 获取浮动费率数据（用于头部标签和弹窗）
  var initFloatRate = function () {
    $.ajax({
      url: `https://minfo.gildata.com/memcached/json/?${gStockCode}_TransactionRateNew`,
      dataType: "json",
      success: function (res) {
        var transactionRateNew = res;
        // 设置全局变量供 fundOverview.js 使用
        window.transactionRateNewData = transactionRateNew;
        window.isHaveFloatRateGlobal = false;
        window.floatRateListGlobal = [];

        if (transactionRateNew && transactionRateNew.TransactionRate) {
          var transactionRateArr = transactionRateNew.TransactionRate;
          // 管理费率 (chargeratetype === 15000)
          var glf = transactionRateArr.filter(
            function (item) {
              return item && item.chargeratetype === 15000;
            }
          );
          // 附加管理费率 (chargeratetype === 21000)
          var fdglf = transactionRateArr.filter(
            function (item) {
              return item && item.chargeratetype === 21000;
            }
          );

          // 判断是否有浮动费率：管理费多条 或 有附加管理费
          if (glf.length > 1 || fdglf.length > 0) {
            window.isHaveFloatRateGlobal = true;
            // 合并浮动费率数据
            window.floatRateListGlobal = glf.slice();
            if (fdglf.length > 0) {
              window.floatRateListGlobal = window.floatRateListGlobal.concat(fdglf.slice());
            }
            // 添加浮动管理费标签
            tagList.push({
              label: "该产品收取浮动管理费(或业绩报酬)，具体以基金合同为准",
              type: "float-rate",
            });
            // 追加浮动费率标签（不覆盖基础标签）
            var floatRateTagHtml = '<span class="header-tag float-rate-tag">该产品收取浮动管理费(或业绩报酬)，具体以基金合同为准</span>';
            $(".header-tag-box").append(floatRateTagHtml);
          }
        }
      },
      error: function () {
        // 获取失败时设置全局变量
        window.transactionRateNewData = null;
        window.isHaveFloatRateGlobal = false;
        window.floatRateListGlobal = [];
      },
    });
  };

  //将后台返回的数值数据全部转为一维数组
  var tableChange = function (list, names) {
    var dxObj = {};
    dxList.forEach((item) => {
      dxObj[item.secucode] = item;
    });
    return list.map((item, index) => {
      let obj = {};
      Object.keys(names).forEach((nameKey) => {
        obj[names[nameKey]] = item[nameKey];
      });
      //加入第五属性
      if (dxObj[obj.SecuCode] && dxObj[obj.SecuCode].fifthnature) {
        obj["FifthNature"] = dxObj[obj.SecuCode].fifthnature;
      } else {
        obj["FifthNature"] = "";
      }
      if (dxObj[obj.SecuCode] && dxObj[obj.SecuCode].fourthnature) {
        obj["FourthNature"] = dxObj[obj.SecuCode].fourthnature;
      } else {
        obj["FourthNature"] = "";
      }

      return obj;
    });
  };
  initDxList();

  //按钮事件
  $(".buy_btn").click(function () {
    if (butFlag != 1) return;
    let sendMsg = JSON.stringify({
      url: "",
      secucode: fundBaseInfo.secucode,
      key: "buy",
    });
    window.parent.postMessage(sendMsg, "*");
  });
  $(".dt_btn").click(function () {
    if (butFlag != 1) return;
    let sendMsg = JSON.stringify({
      url: "",
      secucode: fundBaseInfo.secucode,
      key: "investment",
    });
    window.parent.postMessage(sendMsg, "*");
  });

  //返回列表
  $("#back-btn").click(function () {
    let sendMsg = JSON.stringify({
      url: "",
      secucode: fundBaseInfo.secucode,
      key: "back",
    });
    console.log(sendMsg, "sendMsg");
    window.parent.postMessage(sendMsg, "*");
  });
});

// utils tool
// var isFalseValue = function (data) {
//   return [null, "--", undefined, "", NaN].includes(data);
// };
// /**
//  * 格式化数据，保留小数
//  * @param {*} data 待处理的数据
//  * @param {Number} len 需要保留的小数位数
//  * @returns {String} 格式化之后的结果
//  */
// var toFixed = function (data, len = 2) {
//   try {
//     if (isFalseValue(data)) return "--";
//     return data.toFixed(len);
//   } catch (e) {
//     return "--";
//   }
// };
// //转换成百分比
// var unitPercent = (data, gap = 1, len = 2) => {
//   try {
//     if (isFalseValue(data)) return "--"; // false 类型返回 --
//     return `${parseFloat(data * gap).toFixed(len)}%`;
//   } catch (e) {
//     return "--";
//   }
// };

// /**
//  * 获取数据量级以及对应的单位
//  * @param {*} value
//  * @returns
//  */
// var getOrder = function (value) {
//   try {
//     if (value > 1000000000000) return { order: 1000000000000, unit: "万亿" };
//     else if (value > 100000000) return { order: 100000000, unit: "亿" };
//     else if (value > 10000) return { order: 10000, unit: "万" };
//     else return { order: 1, unit: "" };
//   } catch (err) {
//     return { order: 1, unit: "" };
//   }
// };

// //排序方法
// var sortNoEmpty = function (arr, field, order = "desc") {
//   const sortedArr = arr.sort((a, b) => {
//     if (a[field] === null || a[field] === undefined || a[field] === "")
//       return 1;
//     if (b[field] === null || b[field] === undefined || b[field] === "")
//       return -1;

//     if (order === "asc") {
//       return a[field] - b[field];
//     } else if (order === "desc") {
//       return b[field] - a[field];
//     } else {
//       throw new Error('Invalid order parameter. Please use "asc" or "desc".');
//     }
//   });

//   return sortedArr;
// };

//chunk 方法
var cus_chunk = function (array, size) {
  var result = [];
  for (var i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/js/public/common.js